"use client";

import { useState } from "react";

/** Long "despre mine" text, folded to a few lines with a toggle. */
export default function ExpandableText({ text, lines = 4 }: { text: string; lines?: number }) {
  const [open, setOpen] = useState(false);
  const long = text.length > 280;
  return (
    <div>
      <p
        className="whitespace-pre-line break-words text-[16px] leading-relaxed text-[#264653]/80"
        style={!open && long ? { display: "-webkit-box", WebkitLineClamp: lines, WebkitBoxOrient: "vertical", overflow: "hidden" } : undefined}
      >
        {text}
      </p>
      {long && (
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="mt-2 text-[14.5px] font-medium text-[#2C969B] hover:underline"
        >
          {open ? "Arată mai puțin" : "Citește tot"}
        </button>
      )}
    </div>
  );
}
